export enum EFolderSettingsOptions {
  RENAME = 'RENAME',
  DELETE = 'DELETE',
}
